// extracted by mini-css-extract-plugin
module.exports = {"errorBoundaryWrapper":"ErrorBoundary_errorBoundaryWrapper__e3EFT"};